import { css } from '@/styled-system/css';

export const calendarControlsStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 'Calendar.Controls.gap',
  paddingInline: 'Calendar.Controls.padding.horz',
  textStyle: 'body-bold',
});
